import { dest } from '#pplx/frontend/apps/ask/widgets/home-primer-tabs/HomepageComponentsProviderShared.js';
const HomepageComponentsProvider = dest.Provider;
export { HomepageComponentsProvider };
//# sourceMappingURL=HomepageComponentsProvider.js.map